import type { IconSvgObject } from './types';

const ChartRoseIcon: IconSvgObject = [
  ["path", { d: "M21 13C21 6.92487 16.0751 2 10 2V13H21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 13C19 17.9706 14.9706 22 10 22V13H19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 13C3 16.866 6.13401 20 10 20V13H3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 13C5 10.2386 7.23858 8 10 8V13H5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ChartRoseIcon;
